export default function inOffsetRectBounds(e, outerRect, itemSpec,endpoint){

  let targetElement = document.querySelector(`[tutorialrole=endpoint][endpoint=${endpoint}]`)

  if( !targetElement ){
    return false;
  }

  let targetBounds = targetElement.getBoundingClientRect();

  let [mouseX,mouseY] = [e.clientX,e.clientY];

  let inXBounds = targetBounds.left <= mouseX && mouseX <= targetBounds.left + targetBounds.width;

  let inYBounds = targetBounds.top <= mouseY && mouseY <= targetBounds.top + targetBounds.height;

  let inBounds = inXBounds && inYBounds;

  let { selector, startMustIncludeSelector, illegalSelectors } = itemSpec;

  if( inBounds ){

    let noIllegalElement = false;
    let includesRequiredSelector = false;

    let path = e.composedPath();

    if( illegalSelectors ){
      let illegalInPath = illegalSelectors.some(illegalSel => path.some(pathEl => {

        let notDoc = pathEl !== document;
        let notWindow = pathEl !== window;
        let htmlEl = notDoc && notWindow;

        let matches = htmlEl && pathEl.matches(illegalSel);

        if( matches ){
          console.error("MATCHED WITH ILLEGAL: " + illegalSel);
        }

        return htmlEl && matches;
      }))
      noIllegalElement = !illegalInPath;
    }else{
      noIllegalElement = true;
    }

    if( startMustIncludeSelector ){
      let endpointElement = document.querySelector(selector);
      
      let inPath = path.includes(endpointElement);
      return inPath;
    }else{
      includesRequiredSelector = true;
    }


    
    return noIllegalElement && includesRequiredSelector;


  }

  return false;
  
}
